import type { ReactElement } from 'react';
import { ContentCard } from '@/shared/ui';
import { QuoteAssetDownloadLink } from './quote-asset-download-link';

interface QuoteAssetsSectionProps {
  readonly quoteRequestId: string;
  readonly assetIds: readonly string[];
}

/** 사용 이미지 원본(견적 설계 §6-2) — 이미지마다 누를 때만 서명 URL 을 받는 다운로드 링크. */
export const QuoteAssetsSection = ({
  quoteRequestId,
  assetIds,
}: QuoteAssetsSectionProps): ReactElement => (
  <ContentCard title="사용 이미지 원본">
    {assetIds.length === 0 ? (
      <p className="text-sm text-muted-foreground">사용한 이미지가 없습니다.</p>
    ) : (
      <ul className="flex flex-col gap-2">
        {assetIds.map((assetId) => (
          <QuoteAssetDownloadLink key={assetId} quoteRequestId={quoteRequestId} assetId={assetId} />
        ))}
      </ul>
    )}
  </ContentCard>
);
